var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMim(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("image", {
    stroke: "null",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAArlBMVEUAAABVUfxUUf1RUvNTUPxST/w+POtqaPt1c/tUUfxYVfxUUfxPT/ZYUvxTUPlVUv3/2VWWlfhTUP6Bf/qYl/j/2lH/3VC5rMFRT/+Tk/1aV/3Fq47xz2KUlP1hXPBqaPyRkPjcw4ySkPh+fP1eW/2Pj/yNjPlkXu+fldWOf8WPgMTIroz/4ExMS/+LfcfFrovz0V7awY1fWvXQupVfWvJ6cNh7cNeLfsSgjrKznp/lxmYvAAAAD3RSTlMAqu0TVqgM8+KeY1gdY1YvvoWKAAAB8UlEQVRYw+2X6XaqMBCAi4BW23uRACEuKGLtlVXt3vd/sTtDmeopOciBY/fvH8nkI1EymZxJUQwJijT02wp0JkGvNbTbVxRFP7cknOvQ1e8eEagdmCyzbAkWg66OelwAWLZZwraMdxIwYOmNSnhLBlQJLi80TfvTmwNrV8Iae3oDCLq4lAo0AxgHMHtvwZ0SfOHBOoIxRmkVAt9EgTMs4aDA9E8vCKoFgVzQVVW1OxgDV9eB7692MsFu5fvB9RVGDfIBB4J+B+gFFGDEvCzgsUEvCHoY33+z+9jcpimKiUwwEbREe85wd5YEJuAfE/gYdSqBB6xywSbhnDsHPyA8JptcsMKoQ4FO+3+5XgC3N+h6iKIoe341OM8ZNDzgqJtbjFovKT8oZwbtf8/ljsO3s7xBCJFmnAQ8S6GBYc9si1GuR/nBIIFpjlx84xQFOSLcC0JBrbMpzsgdmeYJBbSEx4QXJI+pAOoL2H0UhtlTPCmIn7IwjO5ZPQH9jckmFQXpy7OoL5hw+nAQev4AAStoKIjv/hXcxU0Ew+30le2wieCQX8EPEexTWoVAmtIUfZ9Ud5hUKwSypFpO61UCSuuf9mRqdLi2P97bFxjtSxzi72ep0hoWmlTqDuqVus2L7S9xX2hz5Wl/6aq+9n2pm+t7Cv4Dgu7i7HQq/o0AAAAASUVORK5CYII=",
    id: "svg_7",
    height: 30,
    width: 30,
    y: 1,
    x: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMim);
export default __webpack_public_path__ + "static/media/MIM.cdb5b8ef.svg";
export { ForwardRef as ReactComponent };